<div class="main-wrap">
    <router-outlet></router-outlet>

</div>